/* Offer block: bundle cards -> FREE GIFTS -> ADD TO YOUR ORDER -> button -> trust.
   v57: free gifts are added ONLY by the gift guard (ice-freaks-giftguard.js),
   inside the same Add to cart request as the masks. This script no longer
   sends its own separate gift add, which raced the guard and could leave a
   bundle without its gifts. It still adds the goggles if ticked.
   On the Mud Freaks page the tiles show the Mud names and photos. */
(function(){
var IDS=window.IF_ADDON_IDS||{};
var GP=window.IF_GOGGLE_PRICES||{standard:22.95,bundle:17.95,was:'39.95'};
var MUD=!!window.IF_MUD;
var built=false;
var picked={goggles:false};
var qty=1;
var F='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/';

var GIFTS=[
{at:1,name:'Free Shipping',value:null,
 icon:'<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#12161C" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1z"></path><path d="M14 8h4l3 3v5h-7z"></path><circle cx="5.5" cy="18.5" r="2"></circle><circle cx="17.5" cy="18.5" r="2"></circle></svg>'},
{at:2,name:MUD?'Riding Gloves':'Snow Gloves',value:'14.95',
 icon:'<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#12161C" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21V9a1.6 1.6 0 0 1 3.2 0V4.6a1.6 1.6 0 0 1 3.2 0V9a1.6 1.6 0 0 1 3.2 0v6.5A5.5 5.5 0 0 1 12.1 21z"></path><path d="M8 12.5 6.2 14a2 2 0 0 0 0 2.8L8 18.5"></path></svg>'},
{at:3,name:'Mystery Mask',value:'26.95',img:MUD?F+'mfp-mystery.webp?v=1792932448':F+'if-mystery.webp?v=1790010047'}
];

var ADDONS=[
{key:'goggles',name:MUD?'Mud Freaks Trail Goggles':'Ice Freaks Snow Goggles',desc:'Anti-fog mirrored lens. Sits right over the mask.',price:GP.standard,was:GP.was,img:MUD?F+'mfp-goggles.webp?v=1792898567':F+'if-goggles.webp'}
];

function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}

function decorateBundles(){
var w=document.getElementById('if-bundles');
if(!w)return;
var cards=w.querySelectorAll('button');
var b=MUD?'Mud Freaks':'Ice Freaks';
var subs=['1 '+b+' mask','2 '+b+' masks','3 '+b+' masks'];
for(var i=0;i<cards.length&&i<3;i++){
if(cards[i].querySelector('[data-if-sub]'))continue;
var s=el('div','font-size:10px; font-weight:600; color:#7C8792; margin-top:3px;',subs[i]);
s.setAttribute('data-if-sub','1');
cards[i].appendChild(s);
}
}

function buildGifts(before){
if(document.getElementById('if-gifts'))return;
var wrap=el('div','margin:0 0 16px;');
wrap.id='if-gifts';
wrap.innerHTML='<div style="display:flex; align-items:center; gap:8px; margin-bottom:9px;">'+
'<span style="font-weight:800; font-size:11px; color:#5B6672; letter-spacing:0.9px;">FREE GIFTS</span>'+
'<span style="font-weight:800; font-size:10px; color:#FF4D14; letter-spacing:0.9px;">WITH BUNDLE</span>'+
'<span style="flex:1; height:1px; background:#E3E7EC;"></span></div>';
var row=el('div','display:grid; grid-template-columns:repeat(3,1fr); gap:8px;');
row.id='if-gift-row';
wrap.appendChild(row);
before.parentNode.insertBefore(wrap,before);
}

function renderGifts(){
var row=document.getElementById('if-gift-row');
if(!row)return;
row.innerHTML='';
GIFTS.forEach(function(gf){
var on=qty>=gf.at;
var tile=el('div','position:relative; border:1.5px solid '+(on?'#FF4D14':'#E3E7EC')+'; background:'+(on?'#FFF6F2':'#F7F8FA')+'; border-radius:12px; padding:9px 7px 8px; text-align:center; overflow:hidden;');
var art=gf.img
?'<img src="'+gf.img+'" alt="'+gf.name+'" style="width:100%; aspect-ratio:1/1; object-fit:cover; border-radius:8px; display:block;">'
:'<span style="display:flex; align-items:center; justify-content:center; width:100%; aspect-ratio:1/1; border-radius:8px; background:#fff;">'+gf.icon+'</span>';
tile.innerHTML=
'<span style="position:relative; display:block;'+(on?'':' opacity:0.45; filter:grayscale(1);')+'">'+art+'</span>'+
'<span style="position:absolute; top:6px; right:6px; width:20px; height:20px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:10px; font-weight:800; background:'+(on?'#FF4D14':'#C4CBD3')+'; color:#fff;">'+(on?'&#10003;':'&#128274;')+'</span>'+
'<span style="display:block; margin-top:6px; font-size:11px; font-weight:800; line-height:1.2; color:'+(on?'#12161C':'#9AA4AF')+';">'+gf.name+'</span>'+
'<span style="display:block; font-size:10px; font-weight:700; line-height:1.3; margin-top:2px; color:'+(on?'#FF4D14':'#AEB6C0')+';">'+(on?(gf.value?'FREE &middot; $'+gf.value+' value':'UNLOCKED'):gf.at+'+ MASKS')+'</span>';
row.appendChild(tile);
});
}

function paintAddon(row,key){
var on=picked[key];
row.style.borderColor=on?'#FF4D14':'#E3E7EC';
row.style.background=on?'#FFF6F2':'#fff';
var box=row.querySelector('[data-if-box]');
if(box){
box.style.borderColor=on?'#FF4D14':'#C4CBD3';
box.style.background=on?'#FF4D14':'#fff';
box.innerHTML=on?'&#10003;':'';
}
}

function buildAddons(before){
if(document.getElementById('if-addons'))return;
var wrap=el('div','margin:0 0 16px;');
wrap.id='if-addons';
var off=Math.round((1-(GP.standard/parseFloat(GP.was)))*100);
wrap.innerHTML='<div style="display:flex; align-items:center; gap:8px; margin-bottom:9px;">'+
'<span style="font-weight:800; font-size:11px; color:#5B6672; letter-spacing:0.9px;">ADD TO YOUR ORDER</span>'+
'<span style="font-weight:800; font-size:10px; color:#FF4D14; letter-spacing:0.9px;">'+off+'% OFF</span>'+
'<span style="flex:1; height:1px; background:#E3E7EC;"></span></div>';
var list=el('div','display:flex; flex-direction:column; gap:8px;');
ADDONS.forEach(function(a){
var row=el('div','display:flex; align-items:center; gap:11px; border:1.5px solid #E3E7EC; background:#fff; border-radius:13px; padding:10px 12px; cursor:pointer;');
row.innerHTML=
'<img src="'+a.img+'" alt="'+a.name+'" style="width:48px; height:48px; border-radius:9px; object-fit:contain; flex-shrink:0; background:#F4F6F8;">'+
'<span style="flex:1; min-width:0;">'+
'<span style="display:block; font-size:14px; font-weight:800; color:#12161C; line-height:1.25;">'+a.name+'</span>'+
'<span style="display:block; font-size:12.5px; color:#5B6672; line-height:1.4;">'+a.desc+'</span>'+
'<span style="display:block; margin-top:3px; font-size:13px; font-weight:800; color:#12161C;">$'+a.price.toFixed(2)+' <span style="font-weight:600; color:#8E98A3; text-decoration:line-through;">$'+a.was+'</span></span>'+
'</span>'+
'<span data-if-box style="width:23px; height:23px; border-radius:6px; flex-shrink:0; border:2px solid #C4CBD3; background:#fff; display:flex; align-items:center; justify-content:center; color:#fff; font-size:14px; font-weight:800;"></span>';
row.addEventListener('click',function(){
picked[a.key]=!picked[a.key];
paintAddon(row,a.key);
syncTotal();
});
list.appendChild(row);
});
wrap.appendChild(list);
before.parentNode.insertBefore(wrap,before);
}

var totalNote=null;
function goggleNow(){return (qty>=3)?GP.bundle:GP.standard;}
function syncTotal(){
if(!totalNote)return;
var base=parseFloat((document.getElementById('if-total')||{}).innerHTML)||0;
var extra=picked.goggles?goggleNow():0;
if(!extra||!base){totalNote.style.display='none';return;}
totalNote.style.display='block';
totalNote.innerHTML='Masks $'+base.toFixed(2)+' &nbsp;+&nbsp; goggles $'+extra.toFixed(2)+' &nbsp;=&nbsp; <strong style="color:#12161C;">$'+(base+extra).toFixed(2)+'</strong>';
}

function buildTrust(after){
if(document.getElementById('if-trustrow'))return;
var box=el('div','margin-top:16px;');
box.id='if-trustrow';
var items=[
['&#128737;','30-day guarantee',MUD?'Ride in it first':'Wear it on the mountain first'],
['&#128666;','Free worldwide shipping','Fully tracked'],
['&#8617;','Hassle-free returns','No questions asked']
];
var row=el('div','display:grid; grid-template-columns:repeat(auto-fit,minmax(140px,1fr)); gap:10px;');
items.forEach(function(i){
row.appendChild(el('div','display:flex; gap:9px; align-items:flex-start;',
'<span style="font-size:17px; line-height:1.2; flex-shrink:0;">'+i[0]+'</span>'+
'<span><span style="display:block; font-size:12.5px; font-weight:800; color:#12161C; line-height:1.3;">'+i[1]+'</span>'+
'<span style="display:block; font-size:11.5px; color:#5B6672; line-height:1.35;">'+i[2]+'</span></span>'));
});
box.appendChild(row);
after.parentNode.insertBefore(box,after.nextSibling);
}

var passthrough=false;
function wireAdd(){
var btn=document.getElementById('if-add');
if(!btn||btn.getAttribute('data-if-wired'))return;
btn.setAttribute('data-if-wired','1');
btn.addEventListener('click',function(ev){
if(passthrough)return;
if(!picked.goggles)return;
var gid=(qty>=3&&IDS.gogglesBundle)?IDS.gogglesBundle:IDS.goggles;
if(!gid)return;
ev.preventDefault();
ev.stopImmediatePropagation();
var label=btn.innerHTML;
btn.disabled=true; btn.innerHTML='Adding&hellip;';
fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:gid,quantity:1}]})})
.then(function(){btn.disabled=false; btn.innerHTML=label; passthrough=true; btn.click(); passthrough=false;})
.catch(function(){btn.disabled=false; btn.innerHTML=label; passthrough=true; btn.click(); passthrough=false;});
},true);
}

function build(){
if(built)return true;
var units=document.getElementById('if-units');
var addBtn=document.getElementById('if-add');
if(!units||!addBtn)return false;
built=true;
var old=document.getElementById('if-mystery');
if(old)old.remove();
var oldLadder=document.getElementById('if-unlocks');
if(oldLadder)oldLadder.remove();
buildGifts(addBtn);
buildAddons(addBtn);
totalNote=el('div','display:none; margin-top:10px; text-align:center; font-size:13px; color:#5B6672;');
addBtn.parentNode.insertBefore(totalNote,addBtn.nextSibling);
buildTrust(totalNote);
wireAdd();
function refresh(){
var n=units.children.length||1;
if(n!==qty){qty=n;renderGifts();}
decorateBundles();
syncTotal();
}
refresh();
renderGifts();
if(window.MutationObserver){
new MutationObserver(refresh).observe(units,{childList:true});
var t=document.getElementById('if-total');
if(t)new MutationObserver(syncTotal).observe(t,{childList:true,characterData:true,subtree:true});
var b=document.getElementById('if-bundles');
if(b)new MutationObserver(decorateBundles).observe(b,{childList:true});
}
return true;
}

var n=0;
var iv=setInterval(function(){n++;if(build()||n>80)clearInterval(iv);},80);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
